import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the SiriProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SiriProvider {

  constructor(public http: HttpClient) {
    console.log('Hello SiriProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/siri/siri.ts